<template>
  <div class="fb-comments-wrapper">
    <div :data-href="dataHref"
         data-order-by="reverse_time"
         data-numposts="10"
         data-width="100%"
         width="100%"
         class="fb-comments"
    >
      <!--  -->
    </div>
  </div>
</template>
<script>

export default {
  name: 'FacebookComment',
  components: {},
  directives: {},
  props: {
    dataHref: {
      type: String,
      default: window.location.href
      // default: 'https://developers.facebook.com/docs/plugins/comments#configurator'
    },
    dataWidth: {
      type: String,
      default: '100%'
    },
    dataOrderBy: {
      type: String,
      default: 'reverse_time'
    },
    dataNumPosts: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {
    this.setFbAsyncInit()
    this.initFbLoadSDK()
  },
  methods: {
    parseFbXFBML() {
      /* eslint-disable */
      FB.XFBML.parse()
      /* eslint-enable */
    },
    setFbAsyncInit() {
      /* eslint-disable */
      window.fbAsyncInit = () => {
        FB.init({
          appId            : process.env.VUE_APP_FB_APP_ID,
          autoLogAppEvents : true,
          xfbml            : true,
          version          : process.env.VUE_APP_FB_SDK_VER
        });
        // code here
      }
      /* eslint-enable */
    },
    initFbLoadSDK() {
      /* eslint-disable */
      const localeStr = this.$i18n.locale.replace('-', '_'); // need semi before IIFE

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        // js.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.0&appId=340910659677580&autoLogAppEvents=1';
        js.src = `https://connect.facebook.net/${localeStr}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      /* eslint-enable */
    }
  }
}
</script>

<style lang="scss">
.fb-comments-wrapper {
  margin-bottom: 48px;
  .fb-comments {
    // Workaround with Facebook bug:
    // https://developers.facebook.com/support/bugs/173395380238318
    width: 100% !important;
    text-align: center;
    iframe{
      width: 100% !important;
    }
    span{
      width: 100% !important;
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
